"use client";
import React, { useState } from "react";
import { ImageLink } from "../../utils/constants";
import { Modal } from "react-bootstrap";


const OrderSummary = ({ orderdetails, id, Invocedata }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMeasurements, setSelectedMeasurements] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOpenModal = (measurements, optionName) => {
    setSelectedMeasurements(measurements);
    setSelectedOption(optionName);
    setShowModal(true);
  };

  return (
   <div className="overflow-hidden border rounded">
  <div className="table-responsive">
    <table className="table table-bordered table-sm align-middle mb-0">
      <thead className="table-light text-uppercase small text-center">
        <tr>
          <th style={{ minWidth: "220px" }}>Product</th>
          <th style={{ width: "80px" }}>Qty</th>
          <th style={{ width: "100px" }}>Tax (%)</th>
          <th style={{ width: "120px" }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {orderdetails?.orderItems?.map((item) => (
          <tr key={item.id}>
            <td>
              <div className="d-flex align-items-start gap-10" style={{gap:"10px"}}>
                <img
                  src={ImageLink(item?.productsnapshots?.image)}
                  alt={item.name}
                  className="rounded"
                  style={{ width: "70px", height: "120px", objectFit: "cover" }}
                />
                <div className="d-flex flex-column flex-grow-1" style={{ gap: "4px" }}>
                  <span className="fw-medium text-truncate">{item.name}</span>
                  <span className="small">
                    Price: {item?.productsnapshots?.price} × {item.quantity || 1}
                  </span>
                  {item?.productsnapshots?.size && (
                    <span>Size: {item?.productsnapshots?.size.value}</span>
                  )}
                
                  {item?.productsnapshots?.stitching?.length > 0 && (
                    <div>
                      <p className="fw-bold small text-info mb-1 d-flex align-items-center gap-1">
                        Stitching <i className="fa-solid fa-arrow-down"></i>
                      </p>
                      <ul className="list-unstyled mb-0 ps-2 small">
                        {item?.productsnapshots?.stitching.map((s, idx) => {
                          let measurements = [];
                          if (Array.isArray(s.measurment)) {
                            measurements = s.measurment;
                          } else {
                            try {
                              measurements = JSON.parse(s.measurment) || [];
                            } catch {
                              measurements = [];
                            }
                          }
                          return (
                            <li
                              key={idx}
                              className="d-flex justify-content-between align-items-center py-1 border-bottom"
                            >
                              <span>
                                {s.option?.name} {s.option?.price && `(${s.option.price})`}
                              </span>
                              {measurements.length > 0 && (
                                <span
                                  role="button"
                                  onClick={() => handleOpenModal(measurements, s.option?.name)}
                                  className="ms-2 text-danger"
                                  title="View Measurements"
                                >
                                  <i className="fa-solid fa-eye"></i>
                                </span>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </td>

            <td className="text-center">{item.quantity || 1}</td>
            <td className="text-center">
              {parseFloat(item?.productsnapshots?.taxPercentage) || 0}
            </td>
            <td className="text-center">{item?.productsnapshots?.subtotal}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  
<Modal show={showModal} onHide={() => setShowModal(false)} centered scrollable>
  <Modal.Header closeButton>
    <Modal.Title>
      <i className="fa-solid fa-scissors text-danger me-2"></i>
      Measurements for {selectedOption}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body style={{padding:"10px"}}>
    {selectedMeasurements.length > 0 ? (
    <div className="row gx-2 gy-2">

        {selectedMeasurements.map((m, i) => (
          <div key={i} className="col-6">
            <div className="measurement-box">
              <span className="measurement-index">{i + 1}.</span>
              <span className="measurement-name">{m.name}</span>
              <span className="measurement-value">{m.value}</span>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <p className="text-muted">No measurements available.</p>
    )}
  </Modal.Body>

  <Modal.Footer>
    <button className="btn btn-danger" onClick={() => setShowModal(false)}>
      Close
    </button>
  </Modal.Footer>
</Modal>


</div>

  );
};

export default OrderSummary;
